// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PDPA_wrapper__3y9wU","content":"PDPA_content__37u_A","link":"PDPA_link__2i8CZ","button":"PDPA_button__3Nsx6"};